// extracted by mini-css-extract-plugin
module.exports =  {"digits":"ccfda6eb9f--digits--p5KrR","footer":"ccfda6eb9f--footer--ledQJ","send-button":"ccfda6eb9f--send-button--TNhR8","error":"ccfda6eb9f--error--V1n1l"};